// Where a user should land after auth based on their role.
export function landingFor(user) {
  if (!user) return "/login";
  if (user.role === "super_admin") return "/business-units";
  if (user.business_unit_id) return `/business-units/${user.business_unit_id}`;
  return "/business-units";
}
